import { cannedWorkPackageQuery } from "@common/api/quoting/canned"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/templates/quotes_/$packageId")({
  loader: async ({ context: { queryClient }, params: { packageId } }) => {
    const item = await queryClient.ensureQueryData(
      cannedWorkPackageQuery({ package_id: packageId }),
    )
    return {
      breadcrumb: [
        { label: "Template quotes", href: "/templates/quotes" },
        { label: item.name },
      ],
    }
  },
})
